import { Directive, Injector, } from '@angular/core';

import { ApAlertService, ApComplexModal, ApNotificationService } from 'webcommon/core-ui';
import { FindControlAdditionalSearchParametersDto } from 'webcommon/shared';

import { FcFilterModalContext } from '../../models/index';

@Directive()
export abstract class FcFilterModalBaseComponent extends ApComplexModal<FindControlAdditionalSearchParametersDto> {
  protected readonly apNotificationService: ApNotificationService;
  protected readonly alertService: ApAlertService;

  public fcFilterModalContext: FcFilterModalContext;

  isLoading = false;
  isSaving = false;

  constructor(
    injector: Injector,
  ) {
    super(injector);
    this.apNotificationService = injector.get(ApNotificationService);
    this.alertService = injector.get(ApAlertService);
  }

  onClose(result: FindControlAdditionalSearchParametersDto) {
    this.apClose(result);
  }

  onCancel() {
    super.apUserCancel();
  }
}
